export interface IPositioned {
  id?: string
  position?: number | null
}

export function compareByPosition(a: IPositioned, b: IPositioned): number {
  const hasPositionA = typeof a.position === 'number'
  const hasPositionB = typeof b.position === 'number'
  if(hasPositionA && hasPositionB && a.position !== b.position) {
    return a.position - b.position
  }
  if(hasPositionA !== hasPositionB) {
    return hasPositionA ? -1 : 1
  }
  return String(a.id ?? '').localeCompare(String(b.id ?? ''))
}

export function getNextPosition(items: IPositioned[]): number {
  return items.reduce((max, item) => typeof item.position === 'number' && item.position > max ? item.position : max, -1) + 1
}
